import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError, getCookie  } from '../../utils'


export const VIDPTTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'PT');
export const VIDTPTTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'TPT');


export const requestPartialContract = () => {
    return {
        type: VIDPTTypes.REQUEST,
    };
};

export const receiveVIDContract = (response) => {
    return {
        type: VIDPTTypes.RECEIVE,
        data: response
    };
};

export const receiveVIDContractError = () => {
    return {
        type: VIDPTTypes.ERROR,
    };
};

export const createVidPartialContract = (data) => {
  return dispatch => {
      const apiUrl = `/api/v1/contract/vid_extra_documents/`

      dispatch(requestPartialContract());

      let headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRFToken': getCookie("csrftoken"),
      }

      return fetch(apiUrl, {
          headers: headers,
          method: 'POST',
          body: JSON.stringify(data),
          credentials: 'include',
      })
      .then(parseJSON)
      .then(response => {
          if (response.status !== "error") {
              dispatch(receiveVIDContract(response));    
          } else {
              dispatch(receiveVIDContractError(response))
          }
          return response
      })
      .catch(handleNetworkError);
  };
};

export const requestVIDTPartialContract = () => {
    return {
        type: VIDTPTTypes.REQUEST,
    };
};

export const receiveVIDTContract = (response) => {
    return {
        type: VIDTPTTypes.RECEIVE,
        data: response
    };
};

export const receiveVIDTContractError = () => {
    return {
        type: VIDTPTTypes.ERROR,
    };
};

export const createVidtPartialContract = (data) => {
  return dispatch => {
      const apiUrl = `/api/v1/contract/vidt_extra_documents/`

      dispatch(requestVIDTPartialContract());

      let headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRFToken': getCookie("csrftoken"),
      }

      return fetch(apiUrl, {
          headers: headers,
          method: 'POST',
          body: JSON.stringify(data),
          credentials: 'include',
      })
      .then(parseJSON)
      .then(response => {
          if (response.status !== "error") {
              dispatch(receiveVIDTContract(response));    
          } else {
              dispatch(receiveVIDTContractError(response))
          }
          return response
      })
      .catch(handleNetworkError);
  };
};
